import React from 'react';
import { getCountryWithFlag } from '../lib/countries';

/**
 * Displays a country with its flag emoji.
 * Handles both country codes ("FR") and names ("France").
 *
 * @param {string} country - Country code or name
 * @param {boolean} showName - Show full name (default: true)
 * @param {boolean} showCode - Show ISO code (default: false)
 * @param {'sm'|'default'|'lg'} size - Text size
 * @param {string} className - Extra classes
 */
const CountryDisplay = ({ country, showName = true, showCode = false, size = 'default', className = '' }) => {
  const { code, name, flag } = getCountryWithFlag(country);

  const sizeClasses = {
    sm: 'text-xs',
    default: 'text-sm',
    lg: 'text-base',
  };

  const flagSizes = {
    sm: 'text-sm',
    default: 'text-base',
    lg: 'text-lg',
  };

  return (
    <span className={`inline-flex items-center gap-1 ${sizeClasses[size]} ${className}`}>
      <span className={flagSizes[size]}>{flag}</span>
      {showName && <span>{name}</span>}
      {showCode && <span className="text-muted-foreground">({code})</span>}
    </span>
  );
};

/**
 * Displays a route: origin → destination with flags.
 */
export const CountryRoute = ({ origin, destination, size = 'default', className = '' }) => {
  const orig = getCountryWithFlag(origin);
  const dest = getCountryWithFlag(destination);

  const sizeClasses = {
    sm: 'text-xs',
    default: 'text-sm',
    lg: 'text-base',
  };

  return (
    <span className={`inline-flex items-center gap-1.5 ${sizeClasses[size]} ${className}`}>
      <span>{orig.flag}</span>
      <span>{orig.name}</span>
      <span className="text-muted-foreground">→</span>
      <span>{dest.flag}</span>
      <span>{dest.name}</span>
    </span>
  );
};

export default CountryDisplay;
